import React from 'react';
import { ButtonGroup } from 'src/components/atoms';
import {
  TabPanel,
  TabsHeaderContainer,
  TabsPanelsContainer,
} from './TabsWithButtonGroup.styles';

interface TabsProps {
  headers: Array<string>;
  panels: React.ReactNode[];
  handleTracking?: (index: number) => void;
  onClick: (index: number) => void;
  activeTab: number;
  className?: string;
  id?: string;
  buttonWidth?: string;
  disabledOptions?: string[];
  paddingTop?: string;
  paddingLeft?: string;
}

export const TabsWithButtonGroup = ({
  headers,
  panels,
  handleTracking,
  onClick,
  activeTab,
  className,
  id,
  buttonWidth,
  disabledOptions,
  paddingTop,
  paddingLeft,
}: TabsProps) => {
  const handleClick = (headerOption: string) => {
    const index = headers.indexOf(headerOption);
    handleTracking?.(index);
    onClick(index);
  };

  return (
    <>
      <TabsHeaderContainer paddingTop={paddingTop} paddingLeft={paddingLeft}>
        <ButtonGroup
          options={headers}
          selectedOption={headers[activeTab]}
          setSelectedOption={handleClick}
          id={id}
          buttonGroupOptionTestId="tab-header"
          buttonWidth={buttonWidth}
          disabledOptions={disabledOptions}
        />
      </TabsHeaderContainer>
      <TabsPanelsContainer className={className}>
        {panels.map((panel, index) => (
          <TabPanel
            key={`${panel?.toString}-${index}`}
            active={index === activeTab}
          >
            {panel}
          </TabPanel>
        ))}
      </TabsPanelsContainer>
    </>
  );
};
